import { keyframes } from 'styled-components';
import { CssAnimation } from './CssAnimation';

const frames = keyframes`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
`;

export const GrowLoopAnimation: CssAnimation = {
    duration: 1000,
    keyframes: frames,
    loop: true,
};
